export function mvAnime() {
  window.addEventListener("load", () => {
    const person01 = document.querySelector(".a-person01");
    const person02 = document.querySelector(".a-person02");
    const person03 = document.querySelector(".a-person03");
    const person04 = document.querySelector(".a-person04");
    const logo = document.querySelector(".a-logo");

    person01.classList.add("is-animate");
    person02.classList.add("is-animate");
    person03.classList.add("is-animate");
    person04.classList.add("is-animate");

    setTimeout(()=>{
      logo.classList.add("animate__animated");
      logo.classList.add("animate__bounceIn");
    }, 800)
  })
}
